<div class="inv-page">

  <div class="inv-page__header">
    <div class="inv-page__titles">
      <h1 class="stk-page-title">Készlet</h1>
      <div class="stk-page-sub">Eladható termék csomagok — kész készlet és a komponensekből még összeállítható mennyiség.</div>
    </div>
    <button type="button" class="inv-add-btn" (click)="openProductEditor()">
      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><line x1="12" y1="4" x2="12" y2="20"></line><line x1="4" y1="12" x2="20" y2="12"></line></svg>
      Új termék csomag
    </button>
  </div>

  <!-- Kompakt szűrősor -->
  <div class="inv-filters">
    <div class="inv-search">
      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#9AA098" stroke-width="2" stroke-linecap="round"><circle cx="11" cy="11" r="6.5"></circle><line x1="16" y1="16" x2="21" y2="21"></line></svg>
      <input type="text" [formControl]="searchControl" placeholder="Keresés név vagy SKU…">
    </div>
    <div class="inv-filter-chips">
      <button
        *ngFor="let chip of gameChips"
        type="button"
        class="inv-chip"
        [class.inv-chip--active]="selectedGameId === chip.id"
        (click)="pickGame(chip)"
      >
        <span class="inv-chip__dot" *ngIf="chip.color" [style.background]="chip.color"></span>
        {{ chip.label }}
      </button>
    </div>
    <button
      type="button"
      class="inv-low-toggle"
      [class.inv-low-toggle--active]="limitBelowOnly"
      (click)="toggleLimitBelow()"
    >{{ limitBelowOnly ? 'Összes mutatása' : 'Csak hiányosak' }}</button>
  </div>

  <!-- Táblázat -->
  <div class="inv-card">
    <div class="inv-grid inv-grid--head">
      <div class="inv-grid__label">Termék csomag</div>
      <div class="inv-grid__label">Recept</div>
      <div class="inv-grid__label">Készlet (számolt)</div>
      <div class="inv-grid__label">Önköltség</div>
      <div></div>
    </div>

    <ng-container *ngFor="let row of dataSource()">
      <ng-container *ngFor="let product of row.products">
        <div class="inv-grid inv-grid--row">
          <div class="inv-product">
            <div class="inv-img">
              <img *ngIf="product.image_file" [appFetchComponentImage]="product.image_file" alt="Termék kép">
              <span *ngIf="!product.image_file" class="inv-img__ph">kép</span>
            </div>
            <div class="inv-product__copy">
              <div class="inv-product__name">{{ product.name }}</div>
              <div class="inv-product__meta">
                <span class="inv-product__game" *ngIf="row.game" [style.background]="gameColor(row.game)">{{ row.game }}</span>
                <span class="inv-product__sku">{{ product.sku }}</span>
              </div>
            </div>
          </div>

          <div class="inv-bom-cell">
            <button
              *ngIf="product.children?.length; else noBom"
              type="button"
              class="inv-bom-toggle"
              [class.inv-bom-toggle--open]="isBomOpen(product)"
              title="Összetevők mutatása készlettel"
              (click)="toggleBom(product)"
            >
              {{ product.children.length }} komponens
              <span class="inv-bom-toggle__chev" [class.inv-bom-toggle__chev--open]="isBomOpen(product)">
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><polyline points="6,9 12,15 18,9"></polyline></svg>
              </span>
            </button>
            <ng-template #noBom><span class="inv-bom-none">–</span></ng-template>
          </div>

          <div class="inv-stock-cell">
            <div class="inv-stock-cell__main">
              <span class="inv-stock-pill" [ngClass]="product | stockHighlightClass">{{ product.stock }} db</span>
              <span class="inv-stock-cell__label">{{ product.children?.length ? 'összeállítható' : 'készleten' }}</span>
            </div>
            <span
              *ngIf="product.reserved > 0"
              class="inv-reserved"
              [class.inv-reserved--over]="product.reserved > product.stock"
              title="Aktív, még feladatlan rendelések ennyit foglalnak le ebből a termékből"
            >
              <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><rect x="5" y="11" width="14" height="10" rx="2"></rect><path d="M8 11 V7 a4 4 0 0 1 8 0 v4"></path></svg>
              {{ product.reserved }} db foglalt rendelésekhez
            </span>
          </div>

          <div class="inv-cost" [title]="costTitle(product)">
            <span class="inv-cost__value">{{ product.unit_cost != null ? (product.unit_cost | number:'1.0-0') + ' Ft' : '–' }}</span>
            <span class="inv-cost__flag" *ngIf="product.cost_missing">hiányzó ár</span>
            <span class="inv-cost__flag inv-cost__flag--soft" *ngIf="!product.cost_missing && product.cost_estimated">becsült</span>
          </div>

          <div class="inv-actions">
            <button
              *ngIf="product.reserved > 0"
              type="button"
              class="inv-action inv-action--realloc"
              title="Készlet átruházás"
              (click)="openRealloc(product)"
            >
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="4" y1="8.5" x2="18" y2="8.5"></line><polyline points="15,5.5 18,8.5 15,11.5"></polyline><line x1="20" y1="15.5" x2="6" y2="15.5"></line><polyline points="9,12.5 6,15.5 9,18.5"></polyline></svg>
            </button>
            <button
              *ngIf="canManageStock(product)"
              type="button"
              class="inv-action inv-action--plus"
              title="Készlet hozzáadás"
              (click)="openAddStockDialog(product, true)"
            >
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><line x1="12" y1="4" x2="12" y2="20"></line><line x1="4" y1="12" x2="20" y2="12"></line></svg>
            </button>
            <button
              *ngIf="canManageStock(product)"
              type="button"
              class="inv-action inv-action--minus"
              title="Készlet levonás"
              (click)="openAddStockDialog(product, false)"
            >
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><line x1="4" y1="12" x2="20" y2="12"></line></svg>
            </button>
            <a class="inv-action inv-action--edit" [routerLink]="'/inventory/' + product.id" title="Szerkesztés">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17 3 l4 4 L8 20 H4 v-4 Z"></path></svg>
            </a>
          </div>
        </div>

        <!-- Recept lenyitó -->
        <div class="inv-bom-panel" *ngIf="isBomOpen(product)">
          <div class="inv-bom-panel__kicker">Így épül össze — 1 csomaghoz</div>
          <div class="inv-bom-row" *ngFor="let child of product.children">
            <div class="inv-img inv-img--sm">
              <img *ngIf="child.component_child?.image_file" [appFetchComponentImage]="child.component_child.image_file" alt="Komponens kép">
              <span *ngIf="!child.component_child?.image_file" class="inv-img__ph">kép</span>
            </div>
            <div class="inv-bom-row__copy">
              <div class="inv-bom-row__name">{{ child.component_child?.name }}</div>
              <div class="inv-bom-row__meta">{{ child.component_child?.sku }} · {{ child.quantity }} db / csomag<ng-container *ngIf="child.unit_cost != null"> · {{ child.unit_cost | number:'1.0-0' }} Ft/db</ng-container><span class="inv-cost__flag" *ngIf="child.cost_missing">nincs ár</span></div>
            </div>
            <span
              class="inv-bom-row__stock"
              [ngClass]="child | stockHighlightClass:true"
              [title]="bomChildStockTitle(child)"
            >{{ child.stock || 0 }} db szabad</span>
            <span class="inv-bom-row__enough" [class.inv-bom-row__enough--missing]="bomPerPackage(child) <= 0">
              {{ bomPerPackage(child) > 0 ? bomPerPackage(child) + ' csomaghoz elég' : 'ebből hiányzik' }}
            </span>
            <div class="inv-actions inv-actions--bom">
              <button
                *ngIf="canManageStock(child, true)"
                type="button"
                class="inv-action inv-action--sm inv-action--plus"
                title="Készlet hozzáadás"
                (click)="openAddStockDialog(child, true, true)"
              >
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><line x1="12" y1="4" x2="12" y2="20"></line><line x1="4" y1="12" x2="20" y2="12"></line></svg>
              </button>
              <button
                *ngIf="canManageStock(child, true)"
                type="button"
                class="inv-action inv-action--sm inv-action--minus"
                title="Készlet levonás"
                (click)="openAddStockDialog(child, false, true)"
              >
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><line x1="4" y1="12" x2="20" y2="12"></line></svg>
              </button>
              <a class="inv-action inv-action--sm inv-action--edit" [routerLink]="'/components/' + child.component_child_id" title="Szerkesztés">
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17 3 l4 4 L8 20 H4 v-4 Z"></path></svg>
              </a>
            </div>
          </div>
        </div>
      </ng-container>
    </ng-container>

    <div class="inv-empty" *ngIf="!fetching && !visibleProductCount">Nincs a szűrésnek megfelelő termék csomag.</div>
    <div class="inv-empty" *ngIf="fetching && !visibleProductCount">Betöltés…</div>
  </div>

  <div class="inv-footer">
    <div class="inv-footer__label">{{ totalProducts }} termék csomag · az „összeállítható" a komponens-készletből számolt, hiányzó gyártás nélkül kiszállítható mennyiség</div>
    <div class="inv-pager">
      <div class="inv-pager__size">
        <select [value]="pageSize" (change)="onPageSizeChange($event)">
          <option *ngFor="let option of pageSizeOptions" [value]="option" [selected]="option === pageSize">{{ option }} / oldal</option>
        </select>
        <div class="inv-pager__chevron">
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><polyline points="6,9 12,15 18,9"></polyline></svg>
        </div>
      </div>
      <span class="inv-pager__range">{{ pageRangeLabel }}</span>
      <button type="button" class="inv-pager__btn" [disabled]="!canPrevPage" (click)="prevPage()">Előző</button>
      <button type="button" class="inv-pager__btn" [disabled]="!canNextPage" (click)="nextPage()">Következő</button>
    </div>
  </div>

  <!-- Készlet átruházás modál -->
  <div class="stk-modal-overlay" *ngIf="realloc" (click)="closeRealloc()">
    <div class="realloc-modal" (click)="$event.stopPropagation()">

      <div class="realloc-modal__head">
        <div class="realloc-modal__icon">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#A14D4D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="4" y1="8.5" x2="18" y2="8.5"></line><polyline points="15,5.5 18,8.5 15,11.5"></polyline><line x1="20" y1="15.5" x2="6" y2="15.5"></line><polyline points="9,12.5 6,15.5 9,18.5"></polyline></svg>
        </div>
        <div class="realloc-modal__titles">
          <h3>Készlet átruházás</h3>
          <div>{{ realloc.product?.name }} · {{ realloc.product?.sku }}</div>
        </div>
        <button type="button" class="realloc-modal__close" title="Bezárás" (click)="closeRealloc()">
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><line x1="5" y1="5" x2="19" y2="19"></line><line x1="19" y1="5" x2="5" y2="19"></line></svg>
        </button>
      </div>

      <div class="realloc-modal__chips">
        <span class="realloc-chip">Készleten összesen: {{ realloc.stock }} db</span>
        <span class="realloc-chip">Igény: {{ reallocTotalNeed }} db · {{ realloc.orders.length }} rendelés</span>
        <span class="realloc-chip" [ngClass]="reallocFree > 0 ? 'realloc-chip--yellow' : 'realloc-chip--green'">Szabad most: {{ reallocFree }} db</span>
      </div>
      <div class="realloc-modal__intro">A rendszer időrendben foglalta le a készletet. A − gombbal elveszed a darabot egy rendeléstől, a + gombbal átadod egy másiknak — mentés után a „Hiányzó készlet” jelölések frissülnek.</div>

      <div class="realloc-modal__list">
        <div class="realloc-empty" *ngIf="reallocLoading">Rendelések betöltése…</div>
        <div class="realloc-empty" *ngIf="!reallocLoading && !(reallocDraft?.length)">Nincs aktív, csomagolásra váró rendelés ehhez a termékhez.</div>

        <div
          class="realloc-row"
          *ngFor="let order of reallocDraft; index as i"
          [class.realloc-row--changed]="reallocChanged(i)"
          [class.realloc-row--full]="order.alloc >= order.need"
        >
          <div class="realloc-row__info">
            <div class="realloc-row__title">
              <span class="realloc-row__name">{{ order.customer }}</span>
              <span class="realloc-row__id">{{ order.displayId }}</span>
              <span class="realloc-row__country">{{ order.country }}</span>
              <span class="realloc-row__auto" *ngIf="order.auto && order.alloc > 0" title="A rendszer időrend szerint ehhez a rendeléshez foglalta le az utolsó darabot">Automatikus foglalás</span>
            </div>
            <div class="realloc-row__dates">
              <span class="realloc-row__placed">Beérkezett: {{ order.placedLabel }}</span>
              <span class="realloc-deadline" [ngClass]="'realloc-deadline--' + deadlineTone(order.days)">{{ deadlineLabel(order.days) }}</span>
            </div>
          </div>
          <div class="realloc-row__controls">
            <button
              type="button"
              class="realloc-step"
              [disabled]="!reallocCanMinus(order)"
              title="Darab elvétele ettől a rendeléstől"
              (click)="reallocMinus(i)"
            >−</button>
            <div class="realloc-count"><span class="realloc-count__alloc">{{ order.alloc }}</span><span class="realloc-count__need"> / {{ order.need }} db</span></div>
            <button
              type="button"
              class="realloc-step"
              [disabled]="!reallocCanPlus(order)"
              title="Darab átadása ennek a rendelésnek"
              (click)="reallocPlus(i)"
            >+</button>
            <span class="realloc-status" [ngClass]="order.alloc >= order.need ? 'realloc-status--full' : 'realloc-status--missing'">
              {{ order.alloc >= order.need ? 'Lefoglalva' : 'Hiány' }}
            </span>
          </div>
        </div>
      </div>

      <div class="realloc-modal__footer">
        <div class="realloc-modal__summary">{{ reallocSummary }}</div>
        <button type="button" class="stk-btn stk-btn--ghost" (click)="closeRealloc()">Mégse</button>
        <button
          type="button"
          class="realloc-save"
          [class.realloc-save--enabled]="reallocHasChange"
          [disabled]="!reallocHasChange"
          (click)="saveRealloc()"
        >Átruházás mentése</button>
      </div>

    </div>
  </div>

</div>
